export interface CoverItem {
  id: string;
  title: string;
  cover: string;
  tag: string;
  hot: string;
}

export interface RankItem {
  id: string;
  rank: number;
  title: string;
  cover: string;
  score: number;
  views: string;
}

export interface AlbumItem {
  id: string;
  title: string;
  cover: string;
  tag: string;
  pages: number;
  date: string;
  span: 'lg' | 'md' | 'sm';
}

export interface VideoItem {
  id: string;
  title: string;
  cover: string;
  duration: string;
  views: string;
  tag: string;
}

export interface SetItem {
  id: string;
  title: string;
  cover: string;
  photos: number;
  tag: string;
}

export interface UpdateItem {
  id: string;
  date: string;
  title: string;
  type: string;
}

export const heroCovers: CoverItem[] = [
  {
    id: 'hero-01',
    title: '晨光办公室 · 白衬衫篇',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20cosplay%20portrait%20of%20a%20young%20woman%20dressed%20as%20a%20professional%20secretary%2C%20tailored%20charcoal%20blazer%20and%20crisp%20white%20blouse%2C%20soft%20warm%20studio%20lighting%2C%20plain%20cream%20beige%20seamless%20background%2C%20refined%20fashion%20magazine%20photography%2C%20shallow%20depth%20of%20field%2C%20harmonious%20warm%20neutral%20tones&width=900&height=1200&seq=sec-hero-01&orientation=portrait',
    tag: '写真集',
    hot: '9.8万',
  },
  {
    id: 'hero-02',
    title: '午后档案室 · 铅笔裙篇',
    cover:
      'https://readdy.ai/api/search-image?query=Tasteful%20studio%20portrait%20of%20a%20woman%20cosplaying%20an%20office%20secretary%2C%20fitted%20pencil%20skirt%20and%20soft%20knit%20cardigan%2C%20holding%20a%20document%20folder%2C%20warm%20muted%20lighting%2C%20plain%20soft%20taupe%20background%2C%20editorial%20portrait%20photography%2C%20gentle%20warm%20neutral%20palette%2C%20clean%20and%20modest%20composition&width=900&height=1200&seq=sec-hero-02&orientation=portrait',
    tag: 'cos视频',
    hot: '7.4万',
  },
  {
    id: 'hero-03',
    title: '夜色加班 · 眼镜篇',
    cover:
      'https://readdy.ai/api/search-image?query=Refined%20cosplay%20portrait%20of%20a%20young%20lady%20as%20a%20secretary%20wearing%20thin%20round%20glasses%20and%20a%20vest%20over%20white%20shirt%2C%20cozy%20evening%20warm%20light%2C%20plain%20warm%20grey%20beige%20studio%20background%2C%20editorial%20fashion%20photography%2C%20soft%20tones%2C%20elegant%20and%20modest%20style&width=900&height=1200&seq=sec-hero-03&orientation=portrait',
    tag: '私拍套图',
    hot: '6.1万',
  },
];

export const rankList: RankItem[] = [
  {
    id: 'rank-01',
    rank: 1,
    title: '秘书制服 · 经典白衬衫合集',
    cover:
      'https://readdy.ai/api/search-image?query=Square%20cosplay%20cover%20of%20a%20woman%20in%20classic%20secretary%20white%20shirt%20and%20dark%20blazer%2C%20soft%20warm%20studio%20light%2C%20plain%20cream%20background%2C%20clean%20editorial%20thumbnail%2C%20warm%20neutral%20tones&width=400&height=400&seq=sec-rank-01&orientation=squarish',
    score: 98,
    views: '12.6万',
  },
  {
    id: 'rank-02',
    rank: 2,
    title: '档案室午后 · 暖光写真',
    cover:
      'https://readdy.ai/api/search-image?query=Square%20portrait%20thumbnail%20of%20a%20secretary%20cosplay%20character%20in%20soft%20beige%20office%20wear%2C%20warm%20window%20light%2C%20plain%20muted%20background%2C%20clean%20editorial%20cover%2C%20harmonious%20warm%20tones&width=400&height=400&seq=sec-rank-02&orientation=squarish',
    score: 95,
    views: '10.2万',
  },
  {
    id: 'rank-03',
    rank: 3,
    title: '加班夜话 · 眼镜系列',
    cover:
      'https://readdy.ai/api/search-image?query=Square%20cosplay%20thumbnail%20of%20a%20young%20woman%20with%20glasses%20as%20an%20office%20secretary%2C%20soft%20evening%20light%2C%20plain%20warm%20grey%20background%2C%20clean%20editorial%20cover%2C%20elegant%20modest%20style&width=400&height=400&seq=sec-rank-03&orientation=squarish',
    score: 91,
    views: '8.8万',
  },
  {
    id: 'rank-04',
    rank: 4,
    title: '会议室速记 · 铅笔裙篇',
    cover:
      'https://readdy.ai/api/search-image?query=Square%20thumbnail%20of%20a%20secretary%20cosplay%20in%20a%20pencil%20skirt%20and%20blouse%20holding%20a%20notebook%2C%20warm%20soft%20studio%20light%2C%20plain%20cream%20background%2C%20clean%20editorial%20cover%2C%20warm%20neutral%20palette&width=400&height=400&seq=sec-rank-04&orientation=squarish',
    score: 87,
    views: '7.3万',
  },
  {
    id: 'rank-05',
    rank: 5,
    title: '前台接待 · 微笑特辑',
    cover:
      'https://readdy.ai/api/search-image?query=Square%20cosplay%20cover%20of%20a%20friendly%20receptionist%20secretary%20character%20in%20smart%20office%20attire%2C%20warm%20evening%20lighting%2C%20plain%20soft%20taupe%20background%2C%20clean%20editorial%20thumbnail%2C%20warm%20neutral%20tones&width=400&height=400&seq=sec-rank-05&orientation=squarish',
    score: 84,
    views: '6.5万',
  },
];

export const albumList: AlbumItem[] = [
  {
    id: 'album-01',
    title: '清晨办公室 · 白衬衫写真正片',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20cosplay%20photo%20album%20cover%20of%20a%20secretary%20character%20in%20crisp%20white%20blouse%20by%20a%20bright%20morning%20window%2C%20soft%20warm%20light%2C%20plain%20cream%20studio%20background%2C%20refined%20fashion%20photography%2C%20warm%20neutral%20tones%2C%20modest%20and%20tasteful&width=1000&height=1200&seq=sec-album-01&orientation=portrait',
    tag: '制服写真',
    pages: 48,
    date: '2026-09-28',
    span: 'lg',
  },
  {
    id: 'album-02',
    title: '档案柜前的午后',
    cover:
      'https://readdy.ai/api/search-image?query=Cosplay%20portrait%20of%20a%20secretary%20character%20leaning%20on%20a%20wooden%20filing%20cabinet%2C%20soft%20afternoon%20warm%20light%2C%20plain%20muted%20beige%20background%2C%20editorial%20photography%2C%20warm%20neutral%20palette%2C%20clean%20modest%20composition&width=700&height=900&seq=sec-album-02&orientation=portrait',
    tag: '场景写真',
    pages: 36,
    date: '2026-09-22',
    span: 'md',
  },
  {
    id: 'album-03',
    title: '眼镜与速记本',
    cover:
      'https://readdy.ai/api/search-image?query=Cosplay%20portrait%20of%20a%20lady%20secretary%20wearing%20thin%20glasses%20and%20holding%20a%20small%20notebook%2C%20warm%20indoor%20light%2C%20plain%20soft%20grey%20beige%20background%2C%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20elegant%20modest%20style&width=700&height=900&seq=sec-album-03&orientation=portrait',
    tag: '主题写真',
    pages: 42,
    date: '2026-09-15',
    span: 'md',
  },
  {
    id: 'album-04',
    title: '前台微笑特辑',
    cover:
      'https://readdy.ai/api/search-image?query=Cosplay%20portrait%20of%20a%20friendly%20receptionist%20secretary%20character%20smiling%20warmly%2C%20soft%20studio%20lighting%2C%20plain%20cream%20background%2C%20clean%20editorial%20photography%2C%20warm%20neutral%20palette%2C%20modest%20and%20tasteful&width=700&height=900&seq=sec-album-04&orientation=portrait',
    tag: '日常写真',
    pages: 30,
    date: '2026-09-08',
    span: 'sm',
  },
  {
    id: 'album-05',
    title: '加班夜 · 暖灯系列',
    cover:
      'https://readdy.ai/api/search-image?query=Cosplay%20portrait%20of%20a%20secretary%20character%20working%20late%20under%20warm%20desk%20lamp%20light%2C%20plain%20soft%20taupe%20background%2C%20cinematic%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20elegant%20modest%20composition&width=700&height=900&seq=sec-album-05&orientation=portrait',
    tag: '夜景写真',
    pages: 34,
    date: '2026-09-01',
    span: 'sm',
  },
];

export const videoList: VideoItem[] = [
  {
    id: 'video-01',
    title: '秘书角色扮演 · 全天工作实录 cos短片',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20cover%20of%20a%20secretary%20cosplay%20short%20film%20scene%20in%20a%20warm%20sunlit%20office%2C%20woman%20in%20office%20attire%20at%20a%20desk%2C%20soft%20warm%20light%2C%20plain%20muted%20background%2C%20editorial%20video%20cover%2C%20warm%20neutral%20tones&width=1280&height=720&seq=sec-video-01&orientation=landscape',
    duration: '12:40',
    views: '5.6万',
    tag: '剧情向',
  },
  {
    id: 'video-02',
    title: '制服日常 · 档案整理片段',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20video%20cover%20of%20a%20secretary%20cosplay%20scene%20sorting%20documents%20in%20a%20warm%20office%20room%2C%20soft%20indoor%20light%2C%20plain%20beige%20background%2C%20editorial%20thumbnil%20style%2C%20warm%20neutral%20palette&width=1280&height=720&seq=sec-video-02&orientation=landscape',
    duration: '08:15',
    views: '4.1万',
    tag: '场景向',
  },
  {
    id: 'video-03',
    title: '镜头记录 · 拍摄花絮合集',
    cover:
      'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20wide%20video%20cover%20of%20a%20secretary%20cosplay%20photo%20shoot%20in%20a%20warm%20studio%2C%20soft%20warm%20lighting%2C%20plain%20cream%20background%2C%20editorial%20cover%20style%2C%20warm%20neutral%20tones%2C%20clean%20modest%20look&width=1280&height=720&seq=sec-video-03&orientation=landscape',
    duration: '06:32',
    views: '3.3万',
    tag: '花絮向',
  },
];

export const setList: SetItem[] = [
  {
    id: 'set-01',
    title: '白色衬衫 · 室内自然光',
    cover:
      'https://readdy.ai/api/search-image?query=Private%20photo%20set%20cover%20of%20a%20secretary%20cosplay%20character%20in%20a%20white%20shirt%20under%20soft%20indoor%20natural%20light%2C%20plain%20cream%20background%2C%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20modest%20and%20tasteful&width=600&height=800&seq=sec-set-01&orientation=portrait',
    photos: 32,
    tag: '自然光',
  },
  {
    id: 'set-02',
    title: '铅笔裙 · 影棚暖调',
    cover:
      'https://readdy.ai/api/search-image?query=Private%20photo%20set%20cover%20of%20a%20secretary%20cosplay%20character%20in%20a%20pencil%20skirt%20in%20a%20warm%20studio%2C%20soft%20lighting%2C%20plain%20taupe%20background%2C%20editorial%20photography%2C%20warm%20neutral%20palette%2C%20elegant%20modest%20style&width=600&height=800&seq=sec-set-02&orientation=portrait',
    photos: 28,
    tag: '影棚',
  },
  {
    id: 'set-03',
    title: '眼镜特辑 · 书桌一角',
    cover:
      'https://readdy.ai/api/search-image?query=Private%20photo%20set%20cover%20of%20a%20lady%20secretary%20with%20glasses%20at%20a%20cozy%20desk%2C%20warm%20indoor%20light%2C%20plain%20soft%20beige%20background%2C%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20modest%20composition&width=600&height=800&seq=sec-set-03&orientation=portrait',
    photos: 40,
    tag: '主题',
  },
  {
    id: 'set-04',
    title: '前台日常 · 采光大厅',
    cover:
      'https://readdy.ai/api/search-image?query=Private%20photo%20set%20cover%20of%20a%20receptionist%20secretary%20character%20in%20a%20bright%20daylight%20lobby%2C%20soft%20natural%20light%2C%20plain%20cream%20background%2C%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20tasteful%20style&width=600&height=800&seq=sec-set-04&orientation=portrait',
    photos: 24,
    tag: '日系',
  },
  {
    id: 'set-05',
    title: '制服细节 · 特写合集',
    cover:
      'https://readdy.ai/api/search-image?query=Private%20photo%20set%20cover%20featuring%20close%20detail%20shots%20of%20a%20secretary%20cosplay%20uniform%2C%20fabric%20and%20collar%20details%2C%20warm%20soft%20light%2C%20plain%20muted%20background%2C%20editorial%20macro%20photography%2C%20warm%20neutral%20tones&width=600&height=800&seq=sec-set-05&orientation=portrait',
    photos: 36,
    tag: '细节',
  },
  {
    id: 'set-06',
    title: '黄昏窗边 · 氛围感',
    cover:
      'https://readdy.ai/api/search-image?query=Private%20photo%20set%20cover%20of%20a%20secretary%20cosplay%20character%20sitting%20by%20a%20window%20at%20dusk%2C%20warm%20golden%20light%2C%20plain%20soft%20taupe%20background%2C%20cinematic%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20modest%20style&width=600&height=800&seq=sec-set-06&orientation=portrait',
    photos: 30,
    tag: '氛围',
  },
];

export const updateList: UpdateItem[] = [
  {
    id: 'up-01',
    date: '10-08',
    title: '新增《清晨办公室 · 白衬衫写真正片》共 48 张',
    type: '写真集',
  },
  {
    id: 'up-02',
    date: '10-05',
    title: '上线 cos 短片《秘书角色扮演 · 全天工作实录》',
    type: 'cos视频',
  },
  {
    id: 'up-03',
    date: '10-01',
    title: '补档《眼镜特辑 · 书桌一角》私拍套图 40P',
    type: '私拍套图',
  },
  {
    id: 'up-04',
    date: '09-26',
    title: '更新《前台微笑特辑》场景写真，替换高清源',
    type: '写真集',
  },
  {
    id: 'up-05',
    date: '09-20',
    title: '热度榜周更，经典白衬衫合集重回第一',
    type: '榜单',
  },
];

export const topicTags: string[] = [
  '经典白衬衫',
  '铅笔裙',
  '圆框眼镜',
  '档案室场景',
  '暖光氛围',
  '日常向',
  '夜景加班',
  '前台接待',
  '制服细节',
  '花絮记录',
  '日系清透',
  '剧情短片',
];